import { isoADisplayDDMMYYYYGuiones } from './fechaReporte';

export const RELACION_VENTAS_SOLO_TOTALES_TITULO = 'RELACIÓN DE VENTAS — SOLO TOTALES';

export function formatSoloTotalesMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatSoloTotalesDate(iso) {
  if (!iso) return '—';
  const s = String(iso).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    return isoADisplayDDMMYYYYGuiones(s.slice(0, 10));
  }
  return s;
}

export function normalizeSoloTotalesResumen(raw) {
  if (!raw || typeof raw !== 'object') return null;
  return raw;
}

function cajaFolioLabel(folio, serie) {
  if (folio == null || folio === '') return '—';
  const s = String(serie ?? '').trim();
  return `${folio}${s}`;
}

function normalizeCajaResumenRow(c) {
  if (!c || typeof c !== 'object') return null;
  const folioComienzoRaw = c.folioComienzo ?? c.folio_comienzo;
  const folioFinalRaw = c.folioFinal ?? c.folio_final;
  const folioComienzo =
    folioComienzoRaw === null || folioComienzoRaw === undefined || folioComienzoRaw === ''
      ? null
      : Number(folioComienzoRaw);
  const folioFinal =
    folioFinalRaw === null || folioFinalRaw === undefined || folioFinalRaw === ''
      ? null
      : Number(folioFinalRaw);
  return {
    caja: c.caja ?? c.Caja,
    folioComienzo: Number.isFinite(folioComienzo) ? folioComienzo : null,
    folioFinal: Number.isFinite(folioFinal) ? folioFinal : null,
    serieComienzo: String(c.serieComienzo ?? c.serie_comienzo ?? '').trim(),
    serieFinal: String(c.serieFinal ?? c.serie_final ?? '').trim(),
    hayAbiertas: !!(c.hayAbiertas ?? c.hay_abiertas),
    cheques: Number(c.cheques ?? 0) || 0,
    personas: Number(c.personas ?? 0) || 0,
  };
}

export function buildCajasDisplayRows(cajas = []) {
  return (Array.isArray(cajas) ? cajas : [])
    .map(normalizeCajaResumenRow)
    .filter(
      (c) =>
        c &&
        (c.folioComienzo !== null || c.hayAbiertas || c.cheques > 0),
    )
    .map((c) => ({
      caja: c.caja,
      fCom: c.folioComienzo !== null ? cajaFolioLabel(c.folioComienzo, c.serieComienzo) : '—',
      fFin: c.hayAbiertas ? 'SN' : cajaFolioLabel(c.folioFinal, c.serieFinal),
      cheques: c.cheques ?? 0,
      pax: c.personas ?? 0,
      hayAbiertas: !!c.hayAbiertas,
    }));
}

export function shouldOcultarFoliosSoloTotales({
  sucursalesItems = [],
  sucursalesSeleccionadas = [],
  sucursalesTodas = true,
  sucursales = [],
  ocultarFoliosApi = false,
} = {}) {
  if (ocultarFoliosApi === true) return true;
  if (Array.isArray(sucursalesItems) && sucursalesItems.length > 1) return true;
  if (!sucursalesTodas && sucursalesSeleccionadas.length > 1) return true;
  if (sucursalesTodas && Array.isArray(sucursales) && sucursales.length > 1) return true;
  return false;
}

export function buildCajasTableColumns(ocultarFolios = false) {
  if (ocultarFolios) {
    return [
      { id: 'caja', label: 'Caja', align: 'num' },
      { id: 'cheques', label: 'Cheques', align: 'num' },
      { id: 'pax', label: 'PAX', align: 'num' },
    ];
  }
  return [
    { id: 'caja', label: 'Caja', align: 'num' },
    { id: 'fCom', label: 'F. comienzo', align: 'text' },
    { id: 'fFin', label: 'F. final', align: 'text' },
    { id: 'cheques', label: 'Cheques', align: 'num' },
    { id: 'pax', label: 'PAX', align: 'num' },
  ];
}

export function cajaRowCellValue(row, columnId) {
  if (!row || !columnId) return '—';
  return row[columnId] ?? '—';
}

export function resolveSoloTotalesSecciones(resumen) {
  if (!resumen || typeof resumen !== 'object') return [];
  if (resumen.agrupadoPorTurno === true && Array.isArray(resumen.turnos) && resumen.turnos.length > 0) {
    return resumen.turnos;
  }
  return [resumen];
}

export function buildDesgloseDisplayRows(grupo) {
  if (!grupo || !Array.isArray(grupo.filas)) {
    return { filas: [], totales: null };
  }
  const filas = grupo.filas.map((f) => ({
    nombre: String(f.nombre ?? '???').toUpperCase(),
    pago: f.cantidad ?? 0,
    propina: (f.propina ?? 0) + (f.servicio ?? 0),
    total: (f.cantidad ?? 0) + (f.propina ?? 0) + (f.servicio ?? 0),
    moneda: f.cantidadMoneda > 0 ? f.cantidadMoneda : null,
  }));
  return {
    filas,
    totales: {
      pago: grupo.totalPago ?? 0,
      propina: grupo.totalPropina ?? 0,
      total: grupo.totalTotal ?? 0,
      comPropina: grupo.comPropina ?? 0,
      propSinCom: grupo.propSinCom ?? 0,
    },
  };
}
